/**
 * Mixpanel event names for the Rivyou marketing website.
 *
 * Dashboard tips:
 * - DAU / unique visitors: Insights → "Website Page View" → Unique users, grouped by day
 * - Page opens: Insights → "Website Page View" → Total events
 * - Download clicks: Insights → "Download Clicked" → Total or unique, breakdown by `location`
 * - Scroll engagement: Insights → "Page Scrolled" → Unique users, breakdown by `scroll_depth`
 * - Session duration: Insights → "Session Ended" → Average of `duration_seconds`
 */

export const ANALYTICS_EVENTS = {
  /** Fired on every page/route load; use for DAU and page-open counts */
  PAGE_VIEW: "Website Page View",

  /** Fired when a user clicks any app-store download link */
  DOWNLOAD_CLICKED: "Download Clicked",

  /** Fired when a user downloads the case page snapshot PDF */

  /** Fired once per scroll milestone (25 / 50 / 75 / 100) per page */
  PAGE_SCROLLED: "Page Scrolled",

  /** Fired when the tab becomes hidden or the user leaves */
  SESSION_ENDED: "Session Ended",
};

export const DOWNLOAD_LOCATIONS = {
  HERO: "hero",
  NAVBAR_DESKTOP: "navbar_desktop",
  NAVBAR_MOBILE: "navbar_mobile",
  CTA: "cta",
  CTA_APP_STORE: "cta_app_store",
  CTA_PLAY_STORE: "cta_play_store",
  STICKY_MOBILE: "sticky_mobile",
  FOOTER: "footer",
};

export const SCROLL_DEPTHS = [25, 50, 75, 100];
